var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhonebooth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199,
    height: 199,
    viewBox: "0 0 199 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    width: 58.057,
    height: 151.861,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(67.129 26.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M162.857,191.49c0,.008-.005,0,0,.013.01.083.008.052,0-.013",
    transform: "translate(-117.292 -137.917)",
    fill: "#adc0ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M9.758,74.318H60.465a1.315,1.315,0,0,1,1.312,1.312V198.339a1.315,1.315,0,0,1-1.312,1.312H9.758a1.316,1.316,0,0,1-1.312-1.312V75.63a1.316,1.316,0,0,1,1.312-1.312",
    transform: "translate(-6.083 -53.526)",
    fill: "#5387e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M23.624,88.271H66.7A1.229,1.229,0,0,1,67.923,89.5V203.414a1.228,1.228,0,0,1-1.225,1.225H23.624a1.229,1.229,0,0,1-1.225-1.225V89.5a1.229,1.229,0,0,1,1.225-1.225",
    transform: "translate(-16.133 -63.576)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_403",
    "data-name": "Rectangle 403",
    width: 34.359,
    height: 104.495,
    transform: "translate(11.849 29.303)",
    fill: "#adc0ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M13.678,20.792h50.4V4.37a74.857,74.857,0,0,0-50.4,0Z",
    transform: "translate(-9.851 0)",
    fill: "#5387e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M1.128,517.62h55.8a1.132,1.132,0,0,1,1.128,1.129v4.791a1.132,1.132,0,0,1-1.128,1.128H1.128A1.132,1.132,0,0,1,0,523.54v-4.791a1.132,1.132,0,0,1,1.128-1.129",
    transform: "translate(0 -372.807)",
    fill: "#5387e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_404",
    "data-name": "Rectangle 404",
    width: 40.135,
    height: 6.1,
    transform: "translate(8.961 11.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M60.6,13.571A1.555,1.555,0,0,1,59.553,16.5a73.4,73.4,0,0,0-49.355,0,1.555,1.555,0,0,1-1.049-2.928,76.3,76.3,0,0,1,51.452,0",
    transform: "translate(-5.847 -6.556)",
    fill: "#5387e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M24.335,489.579h44.44l-5.28-4.263H29.616Z",
    transform: "translate(-17.527 -349.541)",
    fill: "#adc0ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_405",
    "data-name": "Rectangle 405",
    width: 2.165,
    height: 106.934,
    transform: "translate(20.233 27.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_406",
    "data-name": "Rectangle 406",
    width: 2.165,
    height: 106.934,
    transform: "translate(35.659 27.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    width: 38.914,
    height: 2.165,
    transform: "translate(9.571 100.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_408",
    "data-name": "Rectangle 408",
    width: 38.914,
    height: 2.165,
    transform: "translate(9.571 41.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_409",
    "data-name": "Rectangle 409",
    width: 38.914,
    height: 2.165,
    transform: "translate(9.571 60.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_410",
    "data-name": "Rectangle 410",
    width: 38.914,
    height: 2.165,
    transform: "translate(9.571 79.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_411",
    "data-name": "Rectangle 411",
    width: 38.914,
    height: 2.165,
    transform: "translate(9.571 118.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M155.625,140.314H145.257a1.092,1.092,0,0,0-1.089,1.089v27.8a1.092,1.092,0,0,0,1.089,1.089h10.368Z",
    transform: "translate(-103.835 -101.059)",
    fill: "#2c4597",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M138.392,154h-2.03a.214.214,0,0,0-.213.213v1.578a.214.214,0,0,0,.213.213l2.03.777Z",
    transform: "translate(-98.059 -110.916)",
    fill: "#2c4597",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_412",
    "data-name": "Rectangle 412",
    width: 0.382,
    height: 27.794,
    transform: "translate(48.394 40.347)",
    fill: "#5387e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M45.42,48.567h.709V46.083h.98v-.577H44.44v.577h.98ZM48.861,48V47.29h1.421v-.551H48.861v-.665H50.47v-.568H48.156v3.061h2.37V48Zm2.9.568H54V47.99H52.468V45.506h-.708ZM55.773,48V47.29h1.421v-.551H55.773v-.665h1.609v-.568H55.069v3.061h2.37V48ZM60,45.506H58.671v3.061h.709v-.844H60c.818,0,1.329-.424,1.329-1.106S60.814,45.506,60,45.506m-.039,1.64H59.38V46.083h.577c.433,0,.652.2.652.534s-.219.529-.652.529m4.639-1.64v1.207H63.206V45.506H62.5v3.061h.708V47.312H64.6v1.255h.708V45.506Zm3.585,3.114a1.586,1.586,0,1,0-1.675-1.583,1.584,1.584,0,0,0,1.675,1.583m0-.6a.98.98,0,1,1,.958-.979.934.934,0,0,1-.958.979m4.985-2.51v1.859l-1.522-1.859h-.586v3.061h.7V46.708l1.526,1.859h.582V45.506ZM75.964,48V47.29h1.421v-.551H75.964v-.665h1.609v-.568H75.26v3.061h2.37V48Z",
    transform: "translate(-32.007 -32.737)",
    fill: "#08143d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M16.063,24.135c-.322.114-.523-.264-.112-.409a74.367,74.367,0,0,1,48.8,0c.411.145.21.524-.112.409a73.973,73.973,0,0,0-48.575,0",
    transform: "translate(-11.322 -14.123)",
    fill: "#2c4597"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M56.95,487.651c10.042,0,18.183.665,18.183,1.486s-8.14,1.486-18.183,1.486-18.182-.665-18.182-1.486,8.14-1.486,18.182-1.486",
    transform: "translate(-27.922 -351.222)",
    fill: "#4a85e9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M116.782,165.722a14.731,14.731,0,0,1-1.879.413c-1.85.125-4.258.141-5.092,2.407-1.39,2.952-4.126,5.551-5.929,8.4-1.425,2.248-4.13,7.437.9,5.885,2.791-.861,6.033-12.186,7.52-12.331.819-.045,3.915-.318,4.473-.846a4.82,4.82,0,0,0,.561-.82c1.9-.614,1.513-.9,2.242-1.721.579-.518-.149-.812-.577-.569-.522.3-.724.735-1.056.917-.1-.577-.3-1.611-.455-2.2-.03-.351-.793-.178-.706.474m-.441,1.913a7.728,7.728,0,0,1-2.077-.216c.625-.274,1.3-.217,1.967-.443a2.456,2.456,0,0,0,.109.659",
    transform: "translate(-73.367 -118.889)",
    fill: "#79aeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M139.556,175.859c.513.015.872-.286,1.4-.27a2.237,2.237,0,0,1-1.463.483c-.5-.029-1-.091-1.5-.075.36-.332,1.113-.152,1.563-.138",
    transform: "translate(-99.387 -126.465)",
    fill: "#537dd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M121.182,167.521a8.886,8.886,0,0,1-2.828-.411c.18-.023.4-.054.646-.089a2.594,2.594,0,0,0-.429-.478.627.627,0,0,1,.507.229.7.7,0,0,1,.041-.4.741.741,0,0,1,.137.609,15.85,15.85,0,0,0,1.749-.342.752.752,0,0,1,.611-.779,1.959,1.959,0,0,1-.034-.221,9.063,9.063,0,0,1-2.094.4c-2.477.156-3.615.227-4.783,2.576-1.472,2.959-4.054,5.5-5.823,8.289l-.207-.283c1.765-2.783,4.345-5.2,5.8-8.139,1.212-2.44,2.4-2.54,4.992-2.7a15.373,15.373,0,0,0,2.109-.413.517.517,0,0,1,.753-.567c.318.21.273.6.36.941.149.585.257.968.3,1.27a4.534,4.534,0,0,1,.933-.79c.449-.213,1.107-.039.73.53a5.047,5.047,0,0,1-1.537,1.637,3.188,3.188,0,0,1-.766.312l-.076.112,0,0h-.018a3.47,3.47,0,0,1-.488.685,3.644,3.644,0,0,1-1.533.525,27.061,27.061,0,0,1-3.02.356c-1.355.144-4.654,11.462-7.516,12.345l-.15-.4c2.551-.787,5.529-10.372,7.241-11.976a1.231,1.231,0,0,1-.79-.512,2.321,2.321,0,0,0,1.231.225,29.682,29.682,0,0,0,2.955-.29,3.526,3.526,0,0,0,1.4-.459,8.532,8.532,0,0,0,.965-1.383c0-.13-.252-.154-.341-.12-.538.2-1,1.051-1.3,1.116a7.472,7.472,0,0,1-1.033.084.9.9,0,0,1-.422.217c.365-.387,1.008-1.617,1.512-1.589-.24.229-.046.122.3.181-.034-.109-.053-.178-.09-.294m1.828-.325a1.89,1.89,0,0,1-.451,1.2,2.388,2.388,0,0,0,.564-.273,6.56,6.56,0,0,0,1.323-1.381c.389-.466-.172-.554-.5-.36-.376.2-.571.576-.941.818m-1.985-.291a11.064,11.064,0,0,1-1.385.24c.482.065.976.091,1.462.112a3.132,3.132,0,0,1-.077-.352m.11,1.1-.417-.077c-.065.086-.131.179-.2.274.185-.077.407-.117.615-.2m-1.04.755a5.965,5.965,0,0,1,.748-.061c.111-.029.3-.249.553-.5-.615.241-.836.036-1.3.565m2.577-1.015c.312-.386-.174-1.873-.271-2.441a.635.635,0,0,0-.114-.294c-.219-.271-.613.118-.42.793.149.525.476,1.581.547,1.809a.436.436,0,0,1,.258.132m-.537-.109c-.1-.4-.188-.869-.314-1.281-.121-.4-.42-.205-.523,0-.229.46.122,1.178.279,1.663a1.92,1.92,0,0,1,.557-.383",
    transform: "translate(-78.272 -118.646)",
    fill: "#537dd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M151.643,169.8c-.177.05-.265-.61-.235-.636.083.016.37.476.235.636",
    transform: "translate(-109.045 -121.84)",
    fill: "#537dd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M65.513,336.624s1.234,9.762.579,11.634c-3.7,10.556.919,15.95-.723,22.132-.852,3.209-1.5,3.309-1.2,4.864s2.156,1.053,3.761,1.4,3.41,2.958,5.967,3.109,2.307-.451,3.159-.652-.1-1-.953-1.354a19.847,19.847,0,0,1-4.713-3.41c-2.109-3.374.941-22.5,1.815-25.7.9-3.309,3.22-10.557,2.718-12.713s-10.406.69-10.406.69",
    transform: "translate(-46.16 -241.369)",
    fill: "#79aeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M66.752,343.149c.3,2.651,1.035,9.032.5,10.557a26.8,26.8,0,0,0-.992,14.4c.574,3.606.861,5.8-.337,9.3a.929.929,0,0,0-.5-.142c1.176-3.418.886-5.558.325-9.08-.618-3.881-1.248-8.341.95-14.616.506-1.443-.246-7.869-.543-10.444.168.007.414.015.6.02M77,342.626c-.255,3.579-1.8,7.925-2.774,11.491a124.391,124.391,0,0,0-2.373,16.661c-.287,4.071-.243,7.6.529,8.837a7.3,7.3,0,0,0,1.459,1.3,1.4,1.4,0,0,0-.725.1,7.17,7.17,0,0,1-1.263-1.087c-.838-1.342-.815-5.017-.521-9.184a134.388,134.388,0,0,1,2.215-16.808c.959-3.515,2.652-7.729,2.932-11.25l.521-.056",
    transform: "translate(-46.931 -246.771)",
    fill: "#537dd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M37.035,337.885a81.3,81.3,0,0,0,2.746,8.327c-4.863,1.719-9.749,7.253-14.655,8.294-1.654.351-2.807-.376-3.535-.251s-1.98.175-1.88,1.679c.1,1.433-3.5,16.965-.543,14.1A2.092,2.092,0,0,0,19.811,369c.15-1.028.2-4.663.527-4.864s4.136-3.26,5.841-4.563a14.487,14.487,0,0,1,5.263-2.373c3.213-.968,14.485-3.876,16.108-6.233,2.575-3.738-.184-10.914-.019-14.081.026-.5-10.5,1-10.5,1",
    transform: "translate(-12.964 -242.56)",
    fill: "#79aeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M43.295,341.212a64.13,64.13,0,0,0,2.216,6.972c.653-.073,1.85-.087,2.049.764-.416-.272-1.689.07-2.23.226-5.2,1.842-9.38,6.849-14.629,7.963-1.613.342-2.5-.35-3.847-.214a.637.637,0,0,0-.1-.517h0c1.375-.154,2.342.537,3.841.219,4.976-1.056,9.41-6.306,14.36-8.189a75.055,75.055,0,0,1-2.389-7.19l.732-.035m9.952-1.135c.264,3.776,2.594,9.7.039,13.409s-16.881,5.189-21.428,8.666c-1.033.79-5.079,3.267-5.815,4.527a1.76,1.76,0,0,0-.379-.275c.849-1.439,4.75-3.807,5.876-4.668,4.533-3.466,18.86-5.352,21.244-8.813,2.348-3.409.46-8.567-.159-12.724Z",
    transform: "translate(-18.485 -244.935)",
    fill: "#537dd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M31.3,125.467c-4.982,4.595,1.184,8.319-1.084,14.6-1.548,4.292,3.158,4.242,2.331,7.995-1.421,6.447,6.827,6.439,6.827,6.439,1.83-3.345.788-15.818,2.724-22.68,1.553-5.5-5-10.925-10.8-6.359",
    transform: "translate(-21.101 -89.133)",
    fill: "#08143d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M61.9,247.8a30.267,30.267,0,0,0-2.32,10.157c-.3,4.5.822,10.375,1.019,14.337.049.985,20.906-.282,21.1-3.491.06-1.011-2.032-5.917-3.055-11.389-1.419-7.593-2.2-12.225-3.108-13.29Z",
    transform: "translate(-42.878 -175.828)",
    fill: "#08143d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M45.606,189.25c.633,1.4,2.5,2.863,3.292,5.389a21.389,21.389,0,0,1,.315,4.8c.112,3.923,16.137-.836,14.688-3.657-.8-1.555-2.482-6.76-2.516-8.434.119-1.65.621-3.779-.97-5.605a25.689,25.689,0,0,0-3.943-3.47,7.349,7.349,0,0,0-4.667-1.929,12.232,12.232,0,0,0-7.142,2.312,3.531,3.531,0,0,0-1.926,2.966c-.219,1.426.472,3.337,1.61,5.245a20.912,20.912,0,0,0,1.26,2.378",
    transform: "translate(-30.751 -127.01)",
    fill: "#5387e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M64.545,199.664c-.2-.336-1.488-2.158-1.282-2.57a16.866,16.866,0,0,1,1.626,1.982Z",
    transform: "translate(-45.548 -141.954)",
    fill: "#0e3085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M46.6,179.9c-1.535.863-3.319,1.519-3.855,3.366-1.148,3.952,6.417,14.162,9.886,13.617-4.109,1.27-11.481-9.374-10.22-13.713.573-1.972,2.381-2.641,4.018-3.572Z",
    transform: "translate(-30.44 -129.355)",
    fill: "#2c4597"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M61.486,473.1c1.752.94,3.958-.265,5.956.649,4.276,1.958,11.587.806,7.173-1.5a24.958,24.958,0,0,1-3.172-2.012c-.614-.5-1.8.262-1.917.58-.281.786-2.943-1.04-4.623-2.82-.985-1.044-1.958-1.687-2.283-1.532a4.956,4.956,0,0,0-1.153,3.125,1.982,1.982,0,0,1-.029.6,10.862,10.862,0,0,0,.049,2.912",
    transform: "translate(-44.197 -335.949)",
    fill: "#08143d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M5.538,399.47c-.209,2.017,1.544,5.09,1.453,7.328-.032.777-.036,1.521,0,2.2.14,2.6,3.731,8.925,4.19,3.991a27.528,27.528,0,0,1,.578-3.843c.328-1.082-1.1-1.353-1.338-1.562-.591-.513.272-4.858,1.236-6.987.6-1.333.857-2.4.585-2.647-2.225-.545-2.617.215-3.977.351a11.092,11.092,0,0,0-2.728,1.173",
    transform: "translate(-3.976 -286.474)",
    fill: "#08143d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M79.466,173.056c8.547,1.4,10.72,7.145,11.741,11.386,1.387,5.765,5.476,6.449,6.216,2.794v1.273c-1.42,2.572-5.238,1.855-6.639-3.967-.992-4.121-3.128-9.712-11.4-11.061-.156-.025-.178-.469.084-.426",
    transform: "translate(-57.09 -124.639)",
    fill: "#2c4597",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M102.83,224.7c-.85-.907,2.756-13.962,0,0",
    transform: "translate(-73.966 -157.217)",
    fill: "#2c4597"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M55.161,145.964c-3.12,2.181-6-.446-7.365-3.409-1-2.162.088-2.447-.154-5.43a14.108,14.108,0,0,0,4.979-.353c1.106-.266,4.895,7.546,2.539,9.192",
    transform: "translate(-34.115 -98.503)",
    fill: "#79aeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M45.53,157.375c-2.891-.944-1.645,3.643,1.157,2.2.813-.42-.417-1.954-1.157-2.2",
    transform: "translate(-31.605 -113.253)",
    fill: "#79aeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M45.85,159.061c1.026-.262,1.755.94,1.24,1.368-.4.377.9-.056.354-.974-.662-1.1-1.845-.355-1.594-.394",
    transform: "translate(-32.998 -114.409)",
    fill: "#537dd2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M55.22,169.651c3.908,4.321,7.945,2.474,4.605-1.1a5.629,5.629,0,0,1-.616-2.9l-5.3-.1a8.744,8.744,0,0,1,1.311,4.095",
    transform: "translate(-38.827 -119.239)",
    fill: "#79aeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M63.089,144.607c.606.321.574.734.525.918-.081.311.132.353.261.138.194-.324.334-.856-.548-1.349-.929-.52-1.591-.931-1.789-2.11-.077-.192-.508,1.31,1.551,2.4",
    transform: "translate(-44.257 -102.408)",
    fill: "#537dd2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M62.132,135.99c.836-.652,1.725-.2,1.266-.145a1.783,1.783,0,0,0-1.065.542c-.443.545-.729.014-.2-.4",
    transform: "translate(-44.544 -97.694)",
    fill: "#08143d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M49.456,143.381c-.323.176-.468.457-.645.535-.374.164-.266-.1-.1-.364a1.955,1.955,0,0,1,.512-.527c.9-.636,1.885-.043.889.139a1.957,1.957,0,0,0-.659.218",
    transform: "translate(-34.974 -102.804)",
    fill: "#08143d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M66.367,157.436a10,10,0,0,1-1.89.957c-.134.2,1.143.749,1.819.182.567-.476.524-1.555.072-1.14",
    transform: "translate(-46.431 -113.323)",
    fill: "#08143d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M66.1,141.32a.527.527,0,1,0,.717.2.527.527,0,0,0-.717-.2",
    transform: "translate(-47.414 -101.735)",
    fill: "#08143d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M54.682,148.79a.527.527,0,1,0,.717.2.527.527,0,0,0-.717-.2",
    transform: "translate(-39.189 -107.116)",
    fill: "#08143d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M54.106,165.872c.669.733,4.685,2.782,6.5.252-1.062,2.682-5.167,1.671-6.5-.252",
    transform: "translate(-38.969 -119.466)",
    fill: "#537dd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M44.152,161.989a1.119,1.119,0,0,0-.779-.888c-2.24-.743-3.473,2.469.4,4.145a43.074,43.074,0,0,0,6.77.818,1.986,1.986,0,0,0,1.584-2.865c-.737-1.8-3.15-1.108-3.689.347L44.541,162.5Z",
    transform: "translate(-29.723 -115.951)",
    fill: "#2c4597",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M56.679,185.215c2.5-.878,1.829-3.748,1.317-5.689-.592-2.248-2.226-10.147-3.367-11.342-.614-1.83-2.5-2.114-2.312-2.5l.263-.551.494.067c.718.051-.5-.978-.617-1.079-.164-.142-.488.105-.488.105s-.346-.464-.557-.488a.835.835,0,0,0-.463.154,3.691,3.691,0,0,0-.927-.4.525.525,0,0,0-.405.222,4.946,4.946,0,0,0-1.18-.168c-.265.054-.368.266-.34.722a9.382,9.382,0,0,0,.122,2.208c.113.309,2.357,1.436,3.284,2.282a12.441,12.441,0,0,1,1.061,1c.687.749.828,7.262.833,8.516.011,2.831-.452,6.138,3.283,6.947",
    transform: "translate(-34.638 -117.75)",
    fill: "#79aeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M50.677,165.078a10.079,10.079,0,0,1,.939-1.173c-.3-.377-.468-.415-.668-.308-.47.252-.82,1.4-1.387,1.41.327-.462.687-.97,1.014-1.4a2.965,2.965,0,0,0-.794-.337.461.461,0,0,0-.325.186c-.231.426-.434,1.24-.837,1.449,0,0,.148-.351.309-.72-.082-.19-.239-.31-.24-.451a.666.666,0,0,1,.332.239c.087-.2.17-.385.229-.507a3.591,3.591,0,0,0-1.028-.144c-.1.021-.13.075-.172.164a8.827,8.827,0,0,0,.049,2.543c0,.328,3.742,2.094,4.493,3.466.657,1.2.715,7.77.695,9.332.074,2.036.186,4.074,1.742,5.239,1.138.852,2.185.849,2.818-.553.557-1.233.075-2.977-.266-4.268-.311-1.179-2.482-11.465-3.388-11.282a2.671,2.671,0,0,0-1.716-1.874c-.437-.229-.615-.471-.476-.758l.421-.9c.138.022.126.151.071.266l.425.114c.061-.033-.019-.2-.043-.233a3.493,3.493,0,0,0-.613-.637c-.128-.094-.263-.111-.467.039-.274.287-.742,1.092-1.118,1.1m3.8,2.69c1.189,1.22,2.8,9.089,3.41,11.41.388,1.469.829,3.385.08,4.681-.848,1.466-1.934,1.331-3.177.529-1.821-1.176-1.792-3.42-1.765-5.568a60.024,60.024,0,0,0-.266-6.724,6.214,6.214,0,0,0-.427-2.366c-.81-1.471-4.273-3.108-4.432-3.541h0a4.934,4.934,0,0,1-.126-1.585c.005-.244.01-.471,0-.648a1.149,1.149,0,0,1,.068-.556.455.455,0,0,1,.344-.26,4.059,4.059,0,0,1,1.166.158.669.669,0,0,1,.454-.246,3.351,3.351,0,0,1,.908.419c.489-.292.718-.083,1.043.318.266-.16.4-.033.6,0,.112.019,1.087.581.755,1.239l-.687-.162-.252.518c-.062.128.166.275.51.455a2.979,2.979,0,0,1,1.792,1.928",
    transform: "translate(-34.404 -117.434)",
    fill: "#537dd2"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 199,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 198,
    height: 198,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonebooth);
export default __webpack_public_path__ + "static/media/phonebooth.b1fb46bdf249591f1cf0e12db2d69cdb.svg";
export { ForwardRef as ReactComponent };